import React, { useState, useContext, useEffect, startTransition } from "react";
import "../../utils/css/leftDiv.css";
import { Context } from "../../../context/DataProvider";
import { trackEvent } from "../../../config/eventHandlers";
import { getCustomerSupportEmailId, HIDE_HELP_SECTION_ENTITY_IDS } from "../../../utils/constants"
import { ScreenName, ACCESSIBILITY_LABELS } from "../../../config/constants";
import dashboardSquareAdd from "../../utils/images/dashboard-square-add.svg";
import iconTimer from "../../utils/images/iconTimer.svg";
import {useTaskDeviceBridge} from "@docsapp/native-wizard-sa/src/lib/useTaskDeviceBridge";
import { handleKeyboardClick } from "../../../utils/keyboardUtils";

const LeftMenuList = [
  {
    id: "summary",
    name: "Summary",
    icon: <img src={dashboardSquareAdd} alt="dashboard-square-add" />,
  },
  {
    id: "your_claims",
    name: "Track Claims",
    icon: <img src={iconTimer} alt="iconTimer" />,
  },
];

export default function LeftDiv() {
  const { setFlag, setTabSwitching, pmEntityId } = useContext(Context);
  const taskDeviceBridge = useTaskDeviceBridge();

  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = localStorage.getItem("activeReimbursementTab");
    return savedTab || LeftMenuList[0].id;
  });

  const clickHapticFeedback = async () => {
    try {
      await taskDeviceBridge.getHapticFeedBack("CLICK");
    } catch (error) {
      console.error("Haptic feedback error:", error);
    }
  };

  const handleTabChange = async (id) => {
    await clickHapticFeedback();
    setTabSwitching(true);
    setActiveTab(id);
    localStorage.setItem("activeReimbursementTab", id);
    startTransition(() => {
      if (id === "summary") {
        setFlag(false);
      } else {
        setFlag(true);
      }
    });
  };

  useEffect(() => {
    startTransition(() => {
      if (activeTab === "summary") {
        setFlag(false);
      } else {
        setFlag(true);
      }
    });
  }, [activeTab]);

  return (
    <div>
      <div
        role={ACCESSIBILITY_LABELS.ROLES.TABLIST}
        aria-label={ACCESSIBILITY_LABELS.NAVIGATION.REIMBURSEMENT_NAV}
        className="nav-bar-vertical"
      >
        {LeftMenuList.map((i) => (
          <div
            key={i.id}
            tabIndex={activeTab === i.id ? "0" : "0"}
            role={ACCESSIBILITY_LABELS.ROLES.TAB}
            aria-selected={activeTab === i.id}
            aria-controls={`tabpanel-${i.id}`}
            id={`tab-${i.id}`}
            aria-label={ACCESSIBILITY_LABELS.TABS.TAB_LABEL(i.name, activeTab === i.id)}
            className={
              activeTab === i.id
                ? "left-nav-item-new left-nav-item-active-new"
                : "left-nav-item-new"
            }
            style={{ width: "100%", borderRadius: "10px" }}
            onClick={() => {
              handleTabChange(i.id);
              if (i.id === "your_claims") trackEvent.yourClaimsClick({ screenName: ScreenName.SUMMARY });
            }}
            onKeyDown={handleKeyboardClick(() => {
              handleTabChange(i.id);
              if (i.id === "your_claims") trackEvent.yourClaimsClick({ screenName: ScreenName.SUMMARY });
            })}
          >
            <div className="left-nav-content">
              <span className="left-nav-icon" aria-hidden="true">{i.icon}</span>
              <span className="left-nav-text"> {i.name}</span>
            </div>
          </div>
        ))}
      </div>
      {pmEntityId !== null && !HIDE_HELP_SECTION_ENTITY_IDS.includes(parseInt(pmEntityId)) && (
        <aside
          className="queries-new"
          tabIndex={0}
          aria-label={ACCESSIBILITY_LABELS.TABS.NEED_HELP(getCustomerSupportEmailId())}
        >
          <div className="queries-header" aria-hidden="true">
            <b>Need help with Claim?</b>
          </div>
          <div className="queries-content" aria-hidden="true">
            <p>
              If you have any questions or concerns about your OPD claims, just drop us an email at{" "}
              <a
                href={`mailto:${getCustomerSupportEmailId()}`}
                tabIndex="-1"
                aria-hidden="true"
              >
                <strong>{getCustomerSupportEmailId()}</strong>
              </a>
              . Our support team will get back to you as soon as possible to help you out.
            </p>
          </div>
        </aside>
      )}
    </div>
  );
}
